export default "__VITE_PUBLIC_ASSET__83134592__"